import { render, staticRenderFns } from "./FaqQuestionItem.vue?vue&type=template&id=7482d420&"
import script from "./FaqQuestionItem.vue?vue&type=script&lang=js&"
export * from "./FaqQuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./FaqQuestionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports